export default "__VITE_ASSET__bd039e80__"